
import fingerprint from '~/mixins/fingerprint'
export default {
    mixins: [fingerprint],
    layout: 'empty',
    data() {
        return {
            deviceId: 'Loading...',
            fingerprint: 'Loading...',
        }
    },
    async mounted() {
        try {
            if (localStorage.getItem('deviceId')) {
                this.deviceId = localStorage.getItem('deviceId')
            } else {
                this.deviceId = await this.getFingerprint()
                localStorage.setItem('deviceId', this.deviceId)
            }
            this.fingerprint = await this.visitorId()
            console.log(this.deviceId)
        } catch (error) {
            console.error('Error generating fingerprint:', error)
        }
    },
    methods: {
        copyToClipboard(text) {
            navigator.clipboard
                .writeText(text)
                .then(() => {
                    this.$toast.success('Copied to clipboard')
                })
                .catch((err) => {
                    console.error('Failed to copy: ', err)
                    this.$toast.error('Failed to copy')
                })
        },
        async getFingerprint() {
            const data = []

            // 1. Basic System Info
            data.push(navigator.language)
            data.push(navigator.hardwareConcurrency)
            data.push(navigator.userActivation)
            data.push(Intl.DateTimeFormat().resolvedOptions().timeZone)
            data.push(window.devicePixelRatio)
            data.push(window.screen.colorDepth)

            // 2. WebGL & Canvas Fingerprinting
            try {
                const canvas = document.createElement('canvas')
                const ctx = canvas.getContext('2d')
                ctx.textBaseline = 'top'
                ctx.font = '14px Arial'
                ctx.fillText('Fingerprinting-Test', 2, 2)
                data.push(canvas.toDataURL())
            } catch (e) {
                data.push('canvas-error')
            }

            // 3. Audio Context Fingerprint
            try {
                const audioCtx = new (window.OfflineAudioContext ||
                    window.AudioContext)(1, 44100, 44100)
                const oscillator = audioCtx.createOscillator()
                const compressor = audioCtx.createDynamicsCompressor()
                oscillator.connect(compressor)
                compressor.connect(audioCtx.destination)
                oscillator.start(0)
                data.push(audioCtx.sampleRate.toString())
            } catch (e) {
                data.push('audio-error')
            }

            // 4. IndexedDB Check
            try {
                if (window.indexedDB) {
                    data.push('indexedDB-supported')
                }
            } catch (error) {
                console.error('Error checking IndexedDB:', error)
            }

            // Convert data to SHA-256 hash
            return await this.hashData(data.join('|'))
        },

        async hashData(str) {
            const encoder = new TextEncoder()
            const data = encoder.encode(str)
            const hashBuffer = await crypto.subtle.digest('SHA-256', data)
            return Array.from(new Uint8Array(hashBuffer))
                .map((b) => b.toString(16).padStart(2, '0'))
                .join('')
        },
    },
}
